import { render, staticRenderFns } from "./grid-item-kynorelle-02.vue?vue&type=template&id=12dca0ad&scoped=true&"
import script from "./grid-item-kynorelle-02.vue?vue&type=script&lang=js&"
export * from "./grid-item-kynorelle-02.vue?vue&type=script&lang=js&"
import style0 from "./grid-item-kynorelle-02.vue?vue&type=style&index=0&id=12dca0ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dca0ad",
  null
  
)

export default component.exports